import axios from 'axios';
import * as yup from 'yup';
export async function signOutRequest() {
    const response = await axios.post('/api/auth/logout');
    return yup
        .object()
        .required()
        .shape({
        message: yup.string().required().oneOf(['OK']),
    })
        .validate(response.data);
}
